module.exports = __webpack_public_path__ + "img/whitelogo.d79c0466.png";